/* ==========================================================================
   YİGİTFY KAPIDA ÖDEME — modal + sipariş POST (TR-UYARLAMA-SPEC §5)
   Bağımlılık yok. theme.liquid her sayfada yükler; modal ([data-ycod])
   yalnız ürün şablonlarında bulunduğundan diğer sayfalarda sessizce çıkar.

   Sözleşme:
   - POST {endpoint}/api/kapida/{store_id}/siparis  (X-Yigitfy-Form-Key başlığı)
   - GET  {endpoint}/api/kapida/adresler            (il/ilçe listesi, 24s cache)
   - sessionStorage "yigitfy_kaynak"  → utm parametreleri + fbclid (theme.js yazar, burada okunur)
   - sessionStorage "yigitfy_iller_v4" → {t: epoch_ms, data: [...]} (oturum
     bitince ölür — panel verisi güncellenince kimse bayat liste görmez)
   - FİYAT GÖNDERİLMEZ: panel aynı yüzdelerle hesaplar, tema yalnız gösterir.
   ========================================================================== */
(function () {
  'use strict';

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  var CITY_CACHE_KEY = 'yigitfy_iller_v4';
  var CITY_CACHE_MS = 30 * 60 * 1000; // 30 dk — veri düzeltmeleri hızlı yayılsın
  var MIN_SUBMIT_MS = 3000;
  // Panel kontratıyla birebir: mahalle listede yoksa (köy) bu değer gönderilir
  // ve köy/mahalle adı mahalle_diger alanında taşınır.
  var MAHALLE_DIGER = '__diger__';
  var MAHALLE_DIGER_LABEL = 'Köyde oturuyorum / mahallem listede yok';

  var M = null; // aktif modal örneği (theme editor bölümü yeniden yüklerse tazelenir)

  /* ---------------------------------------------------- Clarity olayları
     Müşterinin form içindeki YOLCULUĞU izlenir (hangi alanda takıldı, nerede
     vazgeçti). Girilen DEĞERLER asla gönderilmez — yalnız olay adı ve etiket.
     clarity yüklü değilse (ID tanımsız/engellenmiş) sessizce çıkar. */
  function cOlay(ad) {
    try { if (window.clarity) window.clarity('event', ad); } catch (e) {}
  }
  function cEtiket(anahtar, deger) {
    try { if (window.clarity) window.clarity('set', anahtar, String(deger)); } catch (e) {}
  }
  var _gorulenAlanlar = {};
  function cAlanOlayi(alan) {
    if (_gorulenAlanlar[alan]) return;   // alan başına tek olay (gürültü olmasın)
    _gorulenAlanlar[alan] = true;
    cOlay('kapida_alan_' + alan);
  }

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    // Eski tarayıcı yedeği (v4 benzeri)
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function money(cents) {
    var T = window.ArkhelaisTheme;
    if (T && typeof T.formatMoney === 'function') return T.formatMoney(cents);
    var n = (cents / 100).toFixed(2).replace('.', ',');
    return n.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' TL';
  }

  function digitsOnly(v) {
    return String(v || '').replace(/\D+/g, '');
  }

  /** 05XX... biçimine getirir; geçersizse null döner. Kapıda ödeme kurye
      araması + SMS takibi cep ister: yalnız 5XX kabul edilir (sabit hat yok). */
  function normalizePhone(v) {
    var d = digitsOnly(v);
    if (d.indexOf('90') === 0 && d.length === 12) d = d.slice(2);
    if (d.length === 10 && /^5/.test(d)) d = '0' + d;
    if (d.length === 11 && /^05/.test(d)) return d;
    return null;
  }

  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  /* ------------------------------------------------------- modal kurulumu */

  function initModal() {
    var root = $('[data-ycod]');
    if (!root) {
      M = null;
      return;
    }
    if (M && M.root === root) return;

    var tiers = [];
    try {
      tiers = JSON.parse(($('[data-ycod-tiers]', root) || {}).textContent) || [];
    } catch (e) {
      tiers = [];
    }
    if (!tiers.length) tiers = [{ qty: 1, pct: 0, code: '', label: 'Tek Paket' }];

    M = {
      root: root,
      panel: $('.ycod__panel', root),
      form: $('[data-ycod-form]', root),
      success: $('[data-ycod-success]', root),
      alert: $('[data-ycod-alert]', root),
      wa: $('[data-ycod-wa]', root),
      submitBtn: $('[data-ycod-submit]', root),
      submitLabel: $('[data-ycod-submit-label]', root),
      totalEl: $('[data-ycod-total]', root),
      radios: $$('[data-ycod-tier]', root),
      bumpBox: $('[data-ycod-bump]', root),
      hp: $('[data-ycod-hp]', root),
      captchaEl: $('[data-ycod-captcha]', root),
      cfg: {
        endpoint: (root.getAttribute('data-endpoint') || '').replace(/\/+$/, ''),
        storeId: root.getAttribute('data-store-id') || '1',
        formKey: root.getAttribute('data-form-key') || '',
        sitekey: root.getAttribute('data-turnstile') || '',
        metaPixel: root.getAttribute('data-meta-pixel') || '',
        tiktokPixel: root.getAttribute('data-tiktok-pixel') || '',
        variantId: parseInt(root.getAttribute('data-variant-id'), 10) || 0,
        unitPrice: parseInt(root.getAttribute('data-unit-price'), 10) || 0,
        bumpEnabled: root.getAttribute('data-bump-enabled') === '1',
        bumpVariant: parseInt(root.getAttribute('data-bump-variant'), 10) || 0,
        bumpPrice: parseInt(root.getAttribute('data-bump-price'), 10) || 0
      },
      tiers: tiers,
      tierIdx: 0,
      open: false,
      openedAt: 0,
      idKey: null,
      eventId: null,
      captchaToken: '',
      captchaWidget: null,
      captchaLoaded: false,
      citiesLoaded: false,
      manualAddress: false,
      submitting: false,
      succeeded: false,
      lastFocus: null
    };

    // Varsayılan kademe: işaretli radio (yoksa 0)
    M.radios.forEach(function (r, i) {
      if (r.checked) M.tierIdx = i;
      r.addEventListener('change', function () {
        selectTier(i, true);
      });
    });

    if (M.bumpBox) {
      M.bumpBox.addEventListener('change', function () {
        updateTotals();
        cOlay(M.bumpBox.checked ? 'kapida_upsell_eklendi' : 'kapida_upsell_kaldirildi');
      });
    }

    // Alan bazlı yolculuk: hangi alana kadar geldi, nerede bıraktı
    ['ad_soyad', 'telefon', 'il', 'ilce', 'mahalle', 'acik_adres', 'eposta'].forEach(function (alan) {
      var el = $('[data-ycod-field="' + alan + '"]', root);
      if (!el) return;
      el.addEventListener('change', function () { cAlanOlayi(alan); });
      el.addEventListener('blur', function () {
        if (el.value) cAlanOlayi(alan);
      }, true);
    });

    // PDP'deki upsell kutusu (bundle altı) modaldakiyle senkron çalışır
    M.pdpBump = document.querySelector('[data-pdp-bump]');
    if (M.pdpBump && M.bumpBox) {
      M.pdpBump.addEventListener('change', function () {
        M.bumpBox.checked = M.pdpBump.checked;
        updateTotals();
      });
      M.bumpBox.addEventListener('change', function () {
        M.pdpBump.checked = M.bumpBox.checked;
        // theme.js'in PDP toplamları da tazelensin (programatik set event üretmez)
        M.pdpBump.dispatchEvent(new Event('change'));
      });
    }

    if (M.form) {
      M.form.addEventListener('submit', onSubmit);
    }

    bindPhoneInput();
    bindCitySelect();
    updateTotals();
  }

  /* ------------------------------------------------------- kademe/toplam */

  function tierSubtotal(i) {
    var t = M.tiers[i] || M.tiers[0];
    return M.cfg.unitPrice * (t.qty || 1);
  }

  /** KAPIDA ÖDEME toplamı — panel formülüyle BİREBİR:
      birim×(1−%) kuruşa yuvarlanır, adetle çarpılır. */
  function tierTotal(i) {
    var t = M.tiers[i] || M.tiers[0];
    var qty = t.qty || 1;
    var birim = Math.round((M.cfg.unitPrice * (100 - (t.pct || 0))) / 100);
    return birim * qty;
  }

  function bumpChecked() {
    return !!(M.cfg.bumpEnabled && M.cfg.bumpVariant && M.bumpBox && M.bumpBox.checked);
  }

  function grandTotal() {
    return tierTotal(M.tierIdx) + (bumpChecked() ? M.cfg.bumpPrice : 0);
  }

  function updateTotals() {
    if (!M) return;
    var total = money(grandTotal());
    if (M.totalEl) M.totalEl.textContent = total;
    if (M.submitLabel) M.submitLabel.textContent = 'SİPARİŞİ TAMAMLA — ' + total;
  }

  function selectTier(i, fromModal) {
    if (!M || !M.tiers[i]) return;
    M.tierIdx = i;
    if (fromModal) {
      cOlay('kapida_kademe_' + ((M.tiers[i] || {}).qty || 1));
      cEtiket('kademe', (M.tiers[i] || {}).label || '');
    }
    M.radios.forEach(function (r, n) {
      r.checked = n === i;
      var row = r.closest('.ycod__tier');
      if (row) row.classList.toggle('is-selected', n === i);
    });
    updateTotals();
    if (fromModal) syncToPdp(i);
  }

  /** PDP kartındaki radio'yu tetikler — theme.js fiyatları/sticky'yi günceller. */
  function syncToPdp(i) {
    var bundles = $$('[data-bundle-form] [data-bundle]');
    if (!bundles[i]) return;
    var radio = $('input[type="radio"]', bundles[i]);
    if (radio && !radio.checked) radio.click();
  }

  /** Modal açılırken PDP'de seçili kademeyi devralır. */
  function syncFromPdp() {
    var bundles = $$('[data-bundle-form] [data-bundle]');
    if (!bundles.length) return;
    var idx = -1;
    bundles.forEach(function (b, n) {
      var radio = $('input[type="radio"]', b);
      if (radio && radio.checked) idx = n;
    });
    if (idx > -1 && M.tiers[idx]) selectTier(idx, false);
  }

  /* --------------------------------------------------------- aç / kapat */

  function openModal() {
    initModal();
    if (!M || M.open) return;
    if (!M.idKey) {
      M.idKey = uuid();
      M.eventId = uuid();
    }
    M.lastFocus = document.activeElement;
    syncFromPdp();
    updateTotals();
    M.root.hidden = false;
    requestAnimationFrame(function () {
      M.root.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
    M.open = true;
    // İlk açılıştan ölçülür: formu doldurup kapatıp yeniden açan müşteri
    // 3 sn eşiğine yanlışlıkla takılmasın (bot koruması amaca uygun kalır).
    if (!M.openedAt) M.openedAt = Date.now();
    cOlay('kapida_form_acildi');
    cEtiket('urun', (M.root.getAttribute('data-product-title') || '').slice(0, 60));
    cEtiket('kademe', (M.tiers[M.tierIdx] || {}).label || '');
    var closeBtn = $('.ycod__close', M.root);
    if (closeBtn) closeBtn.focus();
    loadCities();
    loadTurnstile();
  }

  function closeModal() {
    if (!M || !M.open) return;
    cOlay(M.succeeded ? 'kapida_kapatildi_siparisli' : 'kapida_kapatildi_siparissiz');
    M.root.classList.remove('is-open');
    M.open = false;
    document.body.style.overflow = '';
    setTimeout(function () {
      if (M && !M.open) M.root.hidden = true;
    }, 260);
    if (M.lastFocus && M.lastFocus.focus) M.lastFocus.focus();
    if (M.succeeded) resetAfterSuccess();
  }

  /** Başarıdan sonra form yeni sipariş için sıfırlanır; kimlikler tazelenir. */
  function resetAfterSuccess() {
    M.succeeded = false;
    M.idKey = uuid();
    M.eventId = uuid();
    if (M.form) {
      M.form.reset();
      M.form.hidden = false;
    }
    if (M.success) M.success.hidden = true;
    selectTier(M.tierIdx, false);
    hideAlerts();
    resetCaptcha();
    updateTotals();
  }

  /* ------------------------------------------------- il / ilçe yükleme */

  function bindCitySelect() {
    var ilSel = getControl('il', true);
    if (!ilSel || ilSel.tagName !== 'SELECT') return;
    ilSel.addEventListener('change', function () {
      fillDistricts(ilSel.value);
    });
    var ilceSel = getControl('ilce', true);
    if (ilceSel && ilceSel.tagName === 'SELECT') {
      ilceSel.addEventListener('change', function () {
        fillMahalle(ilSel.value, ilceSel.value);
      });
    }
    var mahSel = $('select[data-ycod-field="mahalle"]', M.root);
    if (mahSel) {
      mahSel.addEventListener('change', function () {
        toggleMahalleDiger(mahSel.value === MAHALLE_DIGER);
      });
    }
  }

  function toggleMahalleDiger(goster) {
    var kutu = $('[data-ycod-mahalle-diger]', M.root);
    if (kutu) kutu.hidden = !goster;
    if (goster) {
      var inp = getControl('mahalle_diger');
      if (inp && inp.focus) inp.focus();
    } else {
      setFieldError('mahalle_diger', '');
    }
  }

  /** İlçe değişince mahalle listesi panelden çekilir (ilçe başına küçük liste). */
  function resetMahalle(mesaj) {
    var mahSel = $('select[data-ycod-field="mahalle"]', M.root);
    if (!mahSel) return;
    mahSel.innerHTML = '';
    var opt0 = document.createElement('option');
    opt0.value = '';
    opt0.textContent = mesaj || 'Önce ilçe seç';
    mahSel.appendChild(opt0);
    mahSel.disabled = true;
    toggleMahalleDiger(false);
  }

  function fillMahalle(ilName, ilceName) {
    if (M.manualAddress) return;
    if (!ilName || !ilceName) {
      resetMahalle();
      return;
    }
    resetMahalle('Yükleniyor…');
    fetch(
      M.cfg.endpoint +
        '/api/kapida/mahalleler?il=' +
        encodeURIComponent(ilName) +
        '&ilce=' +
        encodeURIComponent(ilceName),
      { headers: { Accept: 'application/json' } }
    )
      .then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.json();
      })
      .then(function (raw) {
        var list = (raw && raw.mahalleler) || [];
        var mahSel = $('select[data-ycod-field="mahalle"]', M.root);
        if (!mahSel) return;
        mahSel.innerHTML = '';
        var opt0 = document.createElement('option');
        opt0.value = '';
        opt0.textContent = 'Mahalle seç';
        mahSel.appendChild(opt0);
        list.forEach(function (mah) {
          var opt = document.createElement('option');
          opt.value = mah;
          opt.textContent = mah;
          mahSel.appendChild(opt);
        });
        // Listenin sonunda sabit köy seçeneği — köyden gelen sipariş kaybolmasın
        var optD = document.createElement('option');
        optD.value = MAHALLE_DIGER;
        optD.textContent = MAHALLE_DIGER_LABEL;
        mahSel.appendChild(optD);
        mahSel.disabled = false;
      })
      .catch(function () {
        // Mahalle listesi gelmezse sipariş engellenmez: köy/serbest alanına düş
        var mahSel = $('select[data-ycod-field="mahalle"]', M.root);
        if (mahSel) {
          mahSel.innerHTML = '';
          var optD = document.createElement('option');
          optD.value = MAHALLE_DIGER;
          optD.textContent = MAHALLE_DIGER_LABEL;
          mahSel.appendChild(optD);
          mahSel.disabled = false;
          mahSel.value = MAHALLE_DIGER;
        }
        toggleMahalleDiger(true);
      });
  }

  function cityCacheRead() {
    try {
      var raw = sessionStorage.getItem(CITY_CACHE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.t || !obj.data) return null;
      if (Date.now() - obj.t > CITY_CACHE_MS) return null;
      return obj.data;
    } catch (e) {
      return null;
    }
  }

  function cityCacheWrite(data) {
    try {
      sessionStorage.setItem(CITY_CACHE_KEY, JSON.stringify({ t: Date.now(), data: data }));
    } catch (e) {}
  }

  /**
   * Beklenen kanonik yanıt: {"iller": [{"il": "Adana", "ilceler": ["Aladağ", ...]}, ...]}
   * Düz dizi veya {"Adana": [...]} sözlüğü de tolere edilir.
   */
  function normalizeCities(raw) {
    if (raw && raw.iller) raw = raw.iller;
    var out = [];
    if (Array.isArray(raw)) {
      raw.forEach(function (item) {
        if (typeof item === 'string') {
          out.push({ il: item, ilceler: [] });
        } else if (item && typeof item === 'object') {
          var name = item.il || item.ad || item.name || '';
          if (name) out.push({ il: String(name), ilceler: item.ilceler || item.districts || [] });
        }
      });
    } else if (raw && typeof raw === 'object') {
      Object.keys(raw).forEach(function (k) {
        out.push({ il: k, ilceler: Array.isArray(raw[k]) ? raw[k] : [] });
      });
    }
    return out;
  }

  function loadCities() {
    if (!M || M.citiesLoaded || M.manualAddress) return;
    var cached = cityCacheRead();
    if (cached && cached.length) {
      fillCities(cached);
      return;
    }
    if (!M.cfg.endpoint) {
      manualAddressMode();
      return;
    }
    fetch(M.cfg.endpoint + '/api/kapida/adresler', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.json();
      })
      .then(function (raw) {
        var list = normalizeCities(raw);
        if (!list.length) throw new Error('bos liste');
        cityCacheWrite(list);
        fillCities(list);
      })
      .catch(function () {
        // Liste gelmedi diye sipariş engellenmez — elle girişe düşülür.
        manualAddressMode();
      });
  }

  function fillCities(list) {
    M.cities = list;
    M.citiesLoaded = true;
    var ilSel = getControl('il', true);
    if (!ilSel || ilSel.tagName !== 'SELECT') return;
    var current = ilSel.value;
    ilSel.innerHTML = '';
    var opt0 = document.createElement('option');
    opt0.value = '';
    opt0.textContent = 'İl seç';
    ilSel.appendChild(opt0);
    list.forEach(function (item) {
      var opt = document.createElement('option');
      opt.value = item.il;
      opt.textContent = item.il;
      ilSel.appendChild(opt);
    });
    if (current) ilSel.value = current;
    fillDistricts(ilSel.value);
  }

  function fillDistricts(ilName) {
    var ilceSel = getControl('ilce', true);
    if (!ilceSel || ilceSel.tagName !== 'SELECT') return;
    ilceSel.innerHTML = '';
    var opt0 = document.createElement('option');
    opt0.value = '';
    if (!ilName) {
      opt0.textContent = 'Önce il seç';
      ilceSel.appendChild(opt0);
      ilceSel.disabled = true;
      return;
    }
    opt0.textContent = 'İlçe seç';
    ilceSel.appendChild(opt0);
    resetMahalle();
    var found = null;
    (M.cities || []).forEach(function (item) {
      if (item.il === ilName) found = item;
    });
    var districts = found ? found.ilceler || [] : [];
    districts.forEach(function (d) {
      var opt = document.createElement('option');
      opt.value = d;
      opt.textContent = d;
      ilceSel.appendChild(opt);
    });
    ilceSel.disabled = false;
  }

  /** Adres listesi alınamadıysa select'ler gizlenir, serbest metin açılır. */
  function manualAddressMode() {
    if (!M || M.manualAddress) return;
    M.manualAddress = true;
    M.root.classList.add('ycod--manual');
    ['il', 'ilce'].forEach(function (name) {
      var sel = $('select[data-ycod-field="' + name + '"]', M.root);
      var txt = $('input[data-ycod-fallback="' + name + '"]', M.root);
      if (sel) {
        sel.hidden = true;
        sel.disabled = true;
      }
      if (txt) txt.hidden = false;
    });
    // Mahalle select'i listesiz çalışamaz: köy/serbest alanı açılır
    var mahSel = $('select[data-ycod-field="mahalle"]', M.root);
    if (mahSel) {
      mahSel.hidden = true;
      mahSel.disabled = true;
      var kutu = mahSel.closest('.ycod__field');
      if (kutu) kutu.hidden = true;
    }
    toggleMahalleDiger(true);
  }

  /** Aktif kontrolü döndürür (select ya da manuel moddaki text input). */
  function getControl(name, preferSelect) {
    if (!M) return null;
    if (M.manualAddress && !preferSelect && (name === 'il' || name === 'ilce')) {
      return $('input[data-ycod-fallback="' + name + '"]', M.root);
    }
    var el = $('[data-ycod-field="' + name + '"]', M.root);
    if (el && el.hidden && (name === 'il' || name === 'ilce')) {
      return $('input[data-ycod-fallback="' + name + '"]', M.root);
    }
    return el;
  }

  /* ------------------------------------------------------ telefon girişi */

  function bindPhoneInput() {
    var tel = getControl('telefon');
    if (!tel) return;
    tel.addEventListener('focus', function () {
      if (!tel.value) tel.value = '0';
    });
    tel.addEventListener('input', function () {
      // 5 ile başlayan girişte otomatik 0 önek — "input'ta otomatik 0 ile başlat"
      var v = tel.value;
      if (/^[5]/.test(v.replace(/\s+/g, ''))) tel.value = '0' + v;
    });
    tel.addEventListener('blur', function () {
      if (tel.value === '0') tel.value = '';
    });
  }

  /* --------------------------------------------------------- doğrulama */

  function setFieldError(name, msg) {
    var err = $('[data-ycod-err="' + name + '"]', M.root);
    var control = getControl(name);
    if (err) {
      err.textContent = msg || '';
      err.hidden = !msg;
    }
    if (control) {
      control.classList.toggle('is-invalid', !!msg);
      if (msg) control.setAttribute('aria-invalid', 'true');
      else control.removeAttribute('aria-invalid');
    }
  }

  function validate() {
    var values = {};
    var firstBad = null;

    function bad(name, msg) {
      setFieldError(name, msg);
      if (!firstBad) firstBad = getControl(name);
    }

    var ad = (getControl('ad_soyad') || {}).value || '';
    ad = ad.trim().replace(/\s+/g, ' ');
    if (ad.length < 5 || ad.indexOf(' ') === -1 || ad.length > 80) {
      bad('ad_soyad', 'Adını ve soyadını birlikte yaz.');
    } else {
      setFieldError('ad_soyad', '');
      values.ad_soyad = ad;
    }

    var telRaw = (getControl('telefon') || {}).value || '';
    var tel = normalizePhone(telRaw);
    if (!tel) {
      bad('telefon', 'Geçerli bir telefon numarası yaz (örn. 05XX XXX XX XX).');
    } else {
      setFieldError('telefon', '');
      values.telefon = tel;
    }

    var il = ((getControl('il') || {}).value || '').trim();
    if (!il) {
      bad('il', 'İlini seç.');
    } else {
      setFieldError('il', '');
      values.il = il;
    }

    var ilce = ((getControl('ilce') || {}).value || '').trim();
    if (!ilce) {
      bad('ilce', M.manualAddress ? 'İlçeni yaz.' : 'İlçeni seç.');
    } else {
      setFieldError('ilce', '');
      values.ilce = ilce;
    }

    var mahalle = '';
    var mahalleDiger = '';
    if (M.manualAddress) {
      // Liste alınamadıysa mahalle de serbest metinden gelir
      mahalle = MAHALLE_DIGER;
      mahalleDiger = ((getControl('mahalle_diger') || {}).value || '').trim();
      if (mahalleDiger.length < 3) {
        bad('mahalle_diger', 'Mahalle ya da köy adını yaz.');
      } else {
        setFieldError('mahalle_diger', '');
      }
    } else {
      mahalle = ((getControl('mahalle') || {}).value || '').trim();
      if (!mahalle) {
        bad('mahalle', 'Mahalleni listeden seç.');
      } else {
        setFieldError('mahalle', '');
      }
      if (mahalle === MAHALLE_DIGER) {
        mahalleDiger = ((getControl('mahalle_diger') || {}).value || '').trim();
        if (mahalleDiger.length < 3) {
          bad('mahalle_diger', 'Köyünün ya da mahallenin adını yaz.');
        } else {
          setFieldError('mahalle_diger', '');
        }
      }
    }
    values.mahalle = mahalle;
    values.mahalle_diger = mahalleDiger;

    var adres = ((getControl('acik_adres') || {}).value || '').trim();
    if (adres.length < 5 || adres.length > 300) {
      bad('acik_adres', 'Adresini biraz daha ayrıntılı yaz (sokak, bina ve daire no).');
    } else {
      setFieldError('acik_adres', '');
      values.acik_adres = adres;
    }

    var eposta = ((getControl('eposta') || {}).value || '').trim();
    if (eposta && (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(eposta) || eposta.length > 254)) {
      bad('eposta', 'E-posta adresi geçerli görünmüyor.');
    } else {
      setFieldError('eposta', '');
      values.eposta = eposta;
    }

    if (firstBad) {
      if (firstBad.focus) firstBad.focus();
      return null;
    }
    return values;
  }

  /* ------------------------------------------------------------- kaynak */

  function buildKaynak() {
    var src = {};
    try {
      src = JSON.parse(sessionStorage.getItem('yigitfy_kaynak')) || {};
    } catch (e) {
      src = {};
    }
    var fbclid = src.fbclid || '';
    if (!fbclid) {
      try {
        fbclid = new URLSearchParams(window.location.search).get('fbclid') || '';
      } catch (e) {}
    }
    return {
      url: window.location.href,
      referrer: document.referrer || '',
      utm_source: src.utm_source || '',
      utm_medium: src.utm_medium || '',
      utm_campaign: src.utm_campaign || '',
      utm_content: src.utm_content || '',
      utm_term: src.utm_term || '',
      fbclid: fbclid,
      fbp: readCookie('_fbp'),
      fbc: readCookie('_fbc'),
      event_id: M.eventId
    };
  }

  /* ------------------------------------------------------------ uyarılar */

  function hideAlerts() {
    if (M.alert) M.alert.hidden = true;
    if (M.wa) M.wa.hidden = true;
  }

  function showAlert(msg) {
    cOlay('kapida_hata_gosterildi');
    if (!M.alert) return;
    M.alert.textContent = msg;
    M.alert.hidden = false;
    M.alert.scrollIntoView({ block: 'nearest' });
  }

  function showWaFallback() {
    showAlert('Sipariş alınamadı. Bağlantını kontrol edip tekrar dene.');
    if (M.wa) M.wa.hidden = false;
  }

  /* ------------------------------------------------------------- gönderim */

  function onSubmit(e) {
    e.preventDefault();
    if (!M || M.submitting) return;
    hideAlerts();

    // Honeypot doluysa hiç gönderme (spec §5.2/8) — sessiz çıkış.
    if (M.hp && M.hp.value) return;

    var tms = Date.now() - M.openedAt;
    if (tms < MIN_SUBMIT_MS) {
      showAlert('Lütfen bilgilerini kontrol edip tekrar dene.');
      return;
    }

    cOlay('kapida_gonder_denendi');
    var values = validate();
    if (!values) {
      cOlay('kapida_dogrulama_hatasi');
      return;
    }

    var tier = M.tiers[M.tierIdx] || M.tiers[0];
    // variant_id METİN olarak gönderilir: panel sözleşmesi string bekler
    // (sayı gönderildiğinde 422 "geçerli bir metin olmalı" hatası dönüyordu).
    var kalemler = [{ variant_id: String(M.cfg.variantId), adet: tier.qty || 1 }];
    var withBump = bumpChecked();
    if (withBump) kalemler.push({ variant_id: String(M.cfg.bumpVariant), adet: 1 });

    var payload = {
      idempotency_key: M.idKey,
      musteri: {
        ad_soyad: values.ad_soyad,
        telefon: values.telefon,
        eposta: values.eposta || ''
      },
      adres: {
        il: values.il,
        ilce: values.ilce,
        mahalle: values.mahalle,
        mahalle_diger: values.mahalle_diger,
        acik_adres: values.acik_adres
      },
      kalemler: kalemler,
      kademe: tier.qty || 1,
      bump: withBump,
      kaynak: buildKaynak(),
      captcha: getCaptchaToken(),
      hp: '',
      t_ms: tms
    };

    M.submitting = true;
    if (M.submitBtn) {
      M.submitBtn.classList.add('is-loading');
      M.submitBtn.setAttribute('aria-disabled', 'true');
    }

    fetch(M.cfg.endpoint + '/api/kapida/' + encodeURIComponent(M.cfg.storeId) + '/siparis', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Yigitfy-Form-Key': M.cfg.formKey
      },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r
          .json()
          .catch(function () {
            return null;
          })
          .then(function (body) {
            return { res: r, body: body };
          });
      })
      .then(function (out) {
        doneSubmitting();
        if (out.res.ok && out.body && out.body.ok) {
          onSuccess(out.body, payload);
          return;
        }
        var msg = (out.body && (out.body.error || out.body.mesaj)) || '';
        if (msg) {
          showAlert(msg);
        } else {
          showWaFallback();
        }
        resetCaptcha();
      })
      .catch(function () {
        doneSubmitting();
        showWaFallback();
        resetCaptcha();
      });
  }

  function doneSubmitting() {
    M.submitting = false;
    if (M.submitBtn) {
      M.submitBtn.classList.remove('is-loading');
      M.submitBtn.removeAttribute('aria-disabled');
    }
  }

  /* ---------------------------------------------------- başarı + piksel */

  function onSuccess(resp, payload) {
    M.succeeded = true;
    cOlay('kapida_siparis_tamamlandi');
    cEtiket('siparis_no', resp.siparis_no || '');
    var totalCents = parseInt(resp.toplam_kurus, 10);
    if (!totalCents || totalCents < 0) totalCents = grandTotal();

    if (M.form) M.form.hidden = true;
    if (M.success) {
      var noEl = $('[data-ycod-order-no]', M.success);
      if (noEl) noEl.textContent = resp.siparis_no ? 'Sipariş No: ' + resp.siparis_no : '';
      var payEl = $('[data-ycod-pay-line]', M.success);
      if (payEl) payEl.textContent = 'Kapıda ' + money(totalCents) + ' ödeyeceksin — kart veya nakit.';
      M.success.hidden = false;
      M.success.focus();
    }

    firePixels(totalCents, payload, resp);
  }

  /** §5.4 — pikseller YALNIZ başarı anında, lazy yüklenir. PageView tetiklenmez. */
  function firePixels(totalCents, payload, resp) {
    var valueTL = Math.round(totalCents) / 100;
    var ids = payload.kalemler.map(function (k) {
      return String(k.variant_id);
    });
    var numItems = payload.kalemler.reduce(function (a, k) {
      return a + (k.adet || 0);
    }, 0);

    // Meta Pixel — fbevents.js lazy init (PageView YOK), Purchase eventID'li (CAPI dedup)
    if (M.cfg.metaPixel) {
      try {
        if (!window.fbq) {
          (function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function () {
              n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = true;
            n.version = '2.0';
            n.queue = [];
            t = b.createElement(e);
            t.async = true;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
          })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        }
        window.fbq('init', M.cfg.metaPixel);
        window.fbq(
          'track',
          'Purchase',
          {
            value: valueTL,
            currency: 'TRY',
            content_ids: ids,
            content_type: 'product',
            num_items: numItems
          },
          { eventID: payload.kaynak.event_id }
        );
      } catch (e) {}
    }

    // TikTok Pixel — lazy load + CompletePayment (otomatik page görünümü çağrılmaz)
    if (M.cfg.tiktokPixel) {
      try {
        if (!window.ttq) {
          (function (w, d, t) {
            w.TiktokAnalyticsObject = t;
            var ttq = (w[t] = w[t] || []);
            ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie'];
            ttq.setAndDefer = function (obj, method) {
              obj[method] = function () {
                obj.push([method].concat(Array.prototype.slice.call(arguments, 0)));
              };
            };
            for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
            ttq.load = function (pixelId) {
              var url = 'https://analytics.tiktok.com/i18n/pixel/events.js';
              ttq._i = ttq._i || {};
              ttq._i[pixelId] = [];
              ttq._i[pixelId]._u = url;
              ttq._t = ttq._t || {};
              ttq._t[pixelId] = +new Date();
              ttq._o = ttq._o || {};
              var s = d.createElement('script');
              s.type = 'text/javascript';
              s.async = true;
              s.src = url + '?sdkid=' + pixelId + '&lib=' + t;
              var f = d.getElementsByTagName('script')[0];
              f.parentNode.insertBefore(s, f);
            };
          })(window, document, 'ttq');
          window.ttq.load(M.cfg.tiktokPixel);
        }
        window.ttq.track('CompletePayment', {
          value: valueTL,
          currency: 'TRY',
          content_id: String(M.cfg.variantId)
        });
      } catch (e) {}
    }

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'yigitfy_cod_purchase',
        value: valueTL,
        order: resp.siparis_no || ''
      });
    } catch (e) {}
  }

  /* ----------------------------------------------------------- turnstile */

  function loadTurnstile() {
    if (!M || !M.captchaEl || !M.cfg.sitekey || M.captchaLoaded) return;
    M.captchaLoaded = true;

    function renderWidget() {
      if (!window.turnstile || M.captchaWidget !== null) return;
      try {
        M.captchaWidget = window.turnstile.render(M.captchaEl, {
          sitekey: M.cfg.sitekey,
          // Kutu normalde görünmez; doğrulama arka planda döner. Cloudflare
          // ziyaretçiden şüphelenirse widget kendiliğinden görünür olur.
          appearance: 'interaction-only',
          callback: function (token) {
            M.captchaToken = token || '';
          },
          'expired-callback': function () {
            M.captchaToken = '';
          },
          'error-callback': function () {
            M.captchaToken = '';
          }
        });
      } catch (e) {}
    }

    if (window.turnstile) {
      renderWidget();
      return;
    }
    window.__ycodTurnstileReady = renderWidget;
    var s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=__ycodTurnstileReady&render=explicit';
    s.async = true;
    s.defer = true;
    document.head.appendChild(s);
  }

  function getCaptchaToken() {
    if (!M.cfg.sitekey) return '';
    try {
      if (window.turnstile && M.captchaWidget !== null) {
        return window.turnstile.getResponse(M.captchaWidget) || M.captchaToken || '';
      }
    } catch (e) {}
    return M.captchaToken || '';
  }

  function resetCaptcha() {
    try {
      if (window.turnstile && M.captchaWidget !== null) window.turnstile.reset(M.captchaWidget);
    } catch (e) {}
    M.captchaToken = '';
  }

  /* ----------------------------------------------------- global dinleyiciler */

  function onDocClick(e) {
    var opener = e.target.closest('[data-cod-open]');
    if (opener) {
      e.preventDefault();
      openModal();
      return;
    }
    if (!M || !M.open) return;
    if (e.target.closest('[data-ycod-close]')) {
      e.preventDefault();
      closeModal();
    }
  }

  function onDocKeydown(e) {
    if (!M || !M.open) return;
    if (e.key === 'Escape') {
      closeModal();
      return;
    }
    if (e.key !== 'Tab') return;
    // Focus trap: sekme modal içinde döner
    var focusables = $$(
      'a[href], button:not([disabled]), input:not([disabled]):not([hidden]), select:not([disabled]):not([hidden]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      M.panel
    ).filter(function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function init() {
    initModal();
  }

  document.addEventListener('click', onDocClick);
  document.addEventListener('keydown', onDocKeydown);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor bölümü yeniden yüklerse elemanları tazele
  document.addEventListener('shopify:section:load', init);
})();
